import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step483248Meta extends BaseModel {
  /**
   * @var {bool}
   */
  hasFirearms;

  /**
   * @var {bool}
   */
  firearmsCount;

  constructor(model = {}) {
    super();
    this.hasFirearms = model.hasFirearms;
    this.firearmsCount = model.firearmsCount;
  }
}
